/**
 * CategoryPicker Component
 * ========================
 * Display categories from CSV with progress tracking and racer counts.
 */

import React from 'react';
import { extractCategoryData } from '../utils/categoryParser';

function CategoryPicker({ categories, categoryMeta, rawRows, selectedCategory, onSelect, progress }) {
  if (!categories || categories.length === 0) {
    return <p>No categories found in file.</p>;
  }

  const getStatus = (category) => {
    const p = progress[category];
    if (!p) return { label: '⏳ Not Started', className: 'pending' };
    if (p.fisExported && p.ussaExported) return { label: '✅ FIS + USSA', className: 'complete' };
    if (p.fisExported) return { label: '🔄 FIS Done', className: 'partial' };
    if (p.ussaExported) return { label: '🔄 USSA Done', className: 'partial' };
    return { label: '⏳ Not Started', className: 'pending' };
  };

  // Get racer count for a category
  const getRacerCount = (categoryName) => {
    if (!categoryMeta || !rawRows) return '?';
    const meta = categoryMeta.find(m => m.name === categoryName);
    if (!meta) return '?';
    try {
      const data = extractCategoryData(rawRows, meta.startIndex);
      return data.length;
    } catch {
      return '?';
    }
  };

  return (
    <div className="category-picker">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Category</th>
            <th>Racers</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => {
            const isSelected = selectedCategory === category;
            const status = getStatus(category);
            const racerCount = getRacerCount(category);
            
            return (
              <tr
                key={category}
                className={`${isSelected ? 'selected' : ''} ${status.className}`}
                onClick={() => onSelect(category)}
              >
                <td>
                  <input
                    type="radio"
                    checked={isSelected}
                    onChange={() => onSelect(category)}
                  />
                </td>
                <td>{category}</td>
                <td className="racer-count">{racerCount}</td>
                <td className={`status ${status.className}`}>{status.label}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default CategoryPicker;
